'use client';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useState } from 'react';

import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import { VARIANT_ENUM } from '@/components/@base/button/type';
import Container from '@/components/@base/container';
import Props from '@/components/app/archive/components/description/type';
import { getArchiveInfoQueryOptions } from '@/components/app/archive/services/hooks';

import { DATA_CY_ARCHIVE_DESCRIPTION, DATA_CY_SHOW_MORE_BUTTON } from '@/constant/cypress';
import localization from '@/constant/localization';

export default function Description({ slug, type }: Props) {
  const [showMore, setShowMore] = useState(false);
  const { data } = useSuspenseQuery(getArchiveInfoQueryOptions(slug, type));

  if (!data || !data.description || data?.description?.length === 0) {
    return null;
  }

  return (
    <Container
      data-cy={DATA_CY_ARCHIVE_DESCRIPTION}
      className='relative mx-auto my-6 w-full max-w-1279 md:my-8 '
    >
      <Container
        className={cn(
          'relative max-h-[200px] overflow-hidden rounded-lg shadow-[0px_10px_25px_0px_#969BA41A]',
          !showMore &&
            'after:absolute after:bottom-0 after:right-0 after:h-full after:w-full after:bg-[linear-gradient(0deg,#FFF_5%,#00000000)]',
          showMore && 'max-h-none',
        )}
      >
        <article
          className='custom-inner-html archive-description mx-4 rounded-lg p-3 shadow-[0px_10px_25px_0px_#969BA41A]'
          dangerouslySetInnerHTML={{ __html: data.description }}
        ></article>
      </Container>
      {!showMore && (
        <Button
          data-cy={DATA_CY_SHOW_MORE_BUTTON}
          variant={VARIANT_ENUM.SOUL}
          className='absolute bottom-4 left-0 right-0 z-10 m-auto w-1/2 md:max-w-[200px]'
          onClick={() => setShowMore(true)}
        >
          {localization.showMore}
        </Button>
      )}
    </Container>
  );
}
